import { deleteLeaf, deleteNode } from '../TreeActions'
import { doInBatches } from '../../../utility'
import {
  appendNodeToTree,
  createLeaf,
  NodeRequestParams,
  updateLeafData,
  updateTreeNode,
} from '../TreeRequests'
import {
  NodeBasedUpdates,
  UpdateData,
  UpdateLeafData,
  UpdateNodeData,
} from './types'

export enum UpdateType {
  leaf = 'leaf',
  node = 'node',
}
export enum UpdateMethod {
  update = 'update',
  delete = 'delete',
  create = 'create',
}

export const idsForNode = (node: {
  id: string
  tree_id?: string
  version?: string
}) => ({
  nodeId: node.id,
  treeId: node.tree_id!,
  versionId: node.version!,
})

export function updateAll(...updates: NodeBasedUpdates[]) {
  const allUpdates = updates.reduce<UpdateData[]>((acc, { updates }) => {
    acc.push(...updates)
    return acc
  }, [])
  return doUpdate(...allUpdates)
}

export function doUpdate(...updateData: UpdateData[]) {
  return doInBatches(updateData, async (update: UpdateData) => {
    switch (update.type) {
      case UpdateType.node:
        return doNodeUpdate(update)
      case UpdateType.leaf:
        return doLeafUpdate(update)
      default:
    }
  })
}

function doNodeUpdate(updateData: UpdateNodeData) {
  const ids = updateData.ids
  const convertedIds = {
    id: ids.nodeId,
    tree_id: ids.treeId,
    version: ids.versionId,
  }
  switch (updateData.method) {
    case UpdateMethod.update:
      return updateTreeNode({
        ...convertedIds,
        ...updateData.params,
      } as NodeRequestParams)
    case UpdateMethod.delete:
      return deleteNode({
        ...ids,
      })
    case UpdateMethod.create:
      return appendNodeToTree({
        ...updateData.params,
        ...convertedIds,
      })
    default:
      throw new Error('node method not implemented')
  }
}

function doLeafUpdate(updateData: UpdateLeafData) {
  const ids = updateData.ids
  const idParmas = {
    tree_id: ids.treeId,
    version: ids.versionId,
    id: ids.nodeId,
  }
  switch (updateData.method) {
    case UpdateMethod.update:
      return updateLeafData({
        ...idParmas,
        ...updateData.params,
      })
    case UpdateMethod.delete:
      return deleteLeaf({
        treeId: ids.treeId,
        versionId: ids.versionId,
        leafId: ids.nodeId,
      })
    case UpdateMethod.create:
      if (!updateData.params) return
      if (!('leaves' in updateData.params)) return
      return createLeaf({
        ...idParmas,
        ...updateData.params,
      })
    default:
      throw new Error('leaf method not implemented')
  }
}
